import { render, staticRenderFns } from "./BiographyBuilder.vue?vue&type=template&id=62c5607a&scoped=true&"
import script from "./BiographyBuilder.vue?vue&type=script&lang=js&"
export * from "./BiographyBuilder.vue?vue&type=script&lang=js&"
import style0 from "./BiographyBuilder.vue?vue&type=style&index=0&id=62c5607a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c5607a",
  null
  
)

component.options.__file = "BiographyBuilder.vue"
export default component.exports